import { z } from 'zod';

import { RoleSchema } from '../enums';
import { IdSchema } from './common';

/** Состояние пользователя, по которому `/` делает редирект (BLUEPRINT 3.8, 6). */
export const AppStateKind = {
  needsOnboarding: 'needsOnboarding',
  inPool: 'inPool',
  inSquad: 'inSquad',
} as const;
export type AppStateKind = (typeof AppStateKind)[keyof typeof AppStateKind];
export const AppStateKindSchema = z.nativeEnum(AppStateKind);

/** Профиль текущего пользователя, который отдаёт `auth.me` (без телефона и tgId). */
export const MeSchema = z.object({
  id: IdSchema,
  firstName: z.string(),
  lastName: z.string().nullable(),
  username: z.string().nullable(),
  photoUrl: z.string().nullable(),
  role: RoleSchema,
  cityId: IdSchema.nullable(),
  /** ISO-строка или null, если онбординг не пройден */
  onboardedAt: z.string().nullable(),
});
export type Me = z.infer<typeof MeSchema>;

export const AppStateSchema = z.object({
  state: AppStateKindSchema,
  user: MeSchema,
  /** Отряды, где пользователь активен (может быть несколько — по активности) */
  squadIds: z.array(IdSchema),
  /** Есть ли активные заявки в пуле */
  poolApplicationIds: z.array(IdSchema),
  /**
   * Фиче-флаги, от которых зависит каркас приложения (Stage 17, задача 7): вкладка «Мои сборы»
   * в нижней панели и панель у человека в пуле появляются только с `feature.myGatherings`.
   * Флаг отдаётся здесь, а не отдельным запросом: `auth.me` уже загружен на каждом экране.
   */
  features: z.object({ myGatherings: z.boolean() }).default({ myGatherings: false }),
});
export type AppState = z.infer<typeof AppStateSchema>;
